import { render, staticRenderFns } from "./CardLoading.vue?vue&type=template&id=16fdac8f"
import script from "./CardLoading.vue?vue&type=script&lang=js"
export * from "./CardLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports